import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import styles from '../Dialog.module.css';

export default function SetAsMainDialog({ data, onAgree, onDismiss, dataChanged }) {
  return (
    <Dialog
      open={data.isOpened}
      keepMounted
      onClose={onDismiss}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {dataChanged ? 
        <div className="flex flex-col justify-center items-center">
          <p>You have unsaved changes. All changes will be lost.</p>
          <p>Do you want to set this CV as your main CV?</p>
        </div> :
        <p>Do you want to set this CV as your main CV?</p>}
      </DialogTitle>
      <DialogActions
        classes={{
          root: styles.popupControls,
        }}
      >
        <Button aria-controls="simple-menu" aria-haspopup="true" onClick={onAgree}>
          Yes
        </Button>
        <Button aria-controls="simple-menu" aria-haspopup="true" onClick={onDismiss}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}
